<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-header height="45px" class="head">
				<el-switch style="padding-left:20px" v-model="showUnrelation" @change="showUnrelationChange" active-text="显示未关联" inactive-text=""></el-switch>
				<el-switch style="padding-left:20px" v-model="showUnsendwln" @change="showUnsendwlnChange" active-text="万里牛未同步" inactive-text=""></el-switch>
				<el-switch style="padding-left:20px" v-model="showUnsendjindie" @change="showUnsendjindieChange" active-text="星空未同步" inactive-text=""></el-switch>
			</el-header>
			<el-main class="main flex">
				<el-row :gutter="20" style="margin: 10px 0px;" v-loading = "staticloading">
					<el-col :span="4">
						<div>
							<el-statistic group-separator="," :precision="2" :value="statistics.czbal"
								title="财资余额"></el-statistic>
						</div>
					</el-col>
					<el-col :span="4">
						<div>
							<el-statistic group-separator="," :precision="2" :value="statistics.wlnbal"
								title="万里牛余额"></el-statistic>
						</div>
					</el-col>
					<el-col :span="4">
						<div>
							<el-statistic group-separator="," :precision="2" :value="statistics.diff"
								title="差额"></el-statistic>
						</div>
					</el-col>
<!-- 					<el-col :span="4">
						<div>
							<el-statistic group-separator="," :precision="2" :value="statistics.jindiesum"
								title="星空余额"></el-statistic>
						</div>
					</el-col> -->
					<el-col :span="4">
						<div>
							<el-statistic group-separator="," :precision="2" :value="statistics.wlnsum"
								title="万里牛流水合计"></el-statistic>
						</div>
					</el-col>
				</el-row>
				<vxe-grid v-if="list_gridOptions" ref="flowcheckreport" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</el-main>
		</el-container>
		
		<bankconfig-index ref="bankconfigIndex"  />
		<statistics-index ref="statistics" :transTime="transTime" @exportdetail="exportdetail" />
		<checkerror-index ref="checkerror" :checkerrordata="checkerrordata" @positioning="positioning" />
		
		
		
		<!-- <edit-index ref="rowedit" :row="currentrow" @success="success" /> -->
<!-- 		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />
		<receipt-index ref="receiptBox" :param="param" />
		<edit-index ref="rowedit" :row="currentrow" @success="success" />	
		<statistics-index ref="statistics" :transTime="transTime" @exportdetail="exportdetail" />	 -->
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;

	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import bankconfigIndex from './lib/bankconfig/index.vue'
	import statisticsIndex from './lib/statistics/index.vue'
	import checkerrorIndex from './lib/checkerror/index.vue'
	
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
		},
		data() {
			return {
				staticloading:false,
				statistics:{
					czbal:0,
					wlnbal:0,
					wlnsum:0,
					jindiesum:0,
					diff:0
				},
				transTime:null,
				currentrow:null,
				showUnsendjindie:false,
				showUnsendwln:false,
				showUnrelation:false,
				showtransferaccount:false,
				loading: false,
				reportName: 'reconciliation_bankflow',
				foreingKey:{},
				checkerrordata:[],
				list_footerField:[
					{field:'amount',toFixed:2}
				],
				list_formConfig: [{
					field: 'transTime',
					title: '时间',
					span: 4,
					resetValue:[this.$Moment().startOf('month').valueOf(),this.$Moment().endOf('month').valueOf()],
					itemRender: {
						defaultValue:[this.$Moment().startOf('month').valueOf(),this.$Moment().endOf('month').valueOf()],
						name: '$datePicker'
					}
				},{
					field: 'serialNo',
					title: '单据编码',
					span: 4,
					itemRender: {
						name: '$input',
						props:{
							
						}
					}
				},{
					field: 'wlnbank',
					title: '万里牛账户',
					span: 4,
					resetValue:'100286',
					itemRender: {
						defaultValue:'100286',
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[]
						}
					}
				},{
					field: 'cdSign',
					title: '收支方向',
					span: 4,
					resetValue:'-1',
					itemRender: {
						defaultValue:'-1',
						name: '$select',
						props:{							
							emptyoption:false,
							selectoptions:[{
								value:'-1',
								label:'全部'
							},{
								value:'0',
								label:'收入'
							},{
								value:'1',
								label:'支出'
							}]
						}
					}
				},{
					field: 'original',
					title: '来源',
					span: 4,
					itemRender: {
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[{
								value:'财资',
								label:'财资'
							},{
								value:'银联',
								label:'银联'
							},{
								value:'云系统',
								label:'云系统【形式】'
							},{
								value:'导入',
								label:'导入'
							}]
						}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list_init() {
				this.$api.bankaccount.list({type:'wln'}).then((res)=>{
					let group = this.$Lodash.groupBy(res.list,'acc_code')
					let wlnbankoptions = []
					//console.log(group)
					for(let i in group){
						let inst_account = []
						group[i].forEach((item)=>{
							if(item.inst_account){
								inst_account.push(item.inst_account)
							}
						})
						group[i][0].inst_account = inst_account.join(',')
						wlnbankoptions.push(group[i][0])
					}
					
					this.wlnbankoptions = wlnbankoptions.map((item)=>{		
						//console.log(item)
						return {
							value:item.acc_code.toString(),
							label:item.acc_name + '【'+(item.inst_account?item.inst_account:'马上填起来')+'】',
							acc_uid:item.acc_uid,
							inst_account:item.inst_account
						}
					})
					this.list_formConfig.forEach((item)=>{
						if(item.field == 'wlnbank'){
							item.itemRender.props.selectoptions = this.wlnbankoptions
						}
					})
					
					this.init_formButton()
					let list_gridOptions = this.list_getOption()
					this.list_beforeCreateGrid(list_gridOptions)
					this.list_gridOptions = list_gridOptions

				})			

			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.id = 'checkerrorreport_list'
				gridOptions.height = 750
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 1000,
					pageSizes: [10, 20, 50,2000,5000],
				}
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '账户设置',
					status: 'danger',
					code: 'bankconfig'
				},{
					name: '统计',
					status: 'primary',
					code: 'paymentsummary'
				},{
					name: '同步万里牛',
					status: 'success',
					code: 'sendwln'
				},{
					name: '同步金蝶',
					status: 'warning',
					code: 'sendjindie'
				},{
					name: '核对星空差异',
					status: '',
					code: 'checkerror'
				}]
				gridOptions.columns = [
						{type:'checkbox',title:'#',fixed:'left',width:50},
						// {type:'seq',title:'',fixed:'left',width:50},
						{field:'serialNo',title:'单据编码',render:'',props:{show:true},fixed:'left',width:150},
						{field:'accName',title:'户名',render:'',props:{
							show:true,
						},width:100},
						{field:'bankAcc',title:'账号',render:'',props:{show:true},width:100},
						{
							field:'transTime',
							title:'时间',
							render:'$datePicker',
							sortable:true,
							props:{show:true},
							formatter:({cellValue})=>{
								return window.systemMethods.timestampToDate(cellValue)
							},
							width:100,
						},
						// {field:'sourceamount',title:'真实流水金额',render:'',props:{show:true},width:100},
						{field:'amount',title:'收入金额',render:'',props:{show:true},width:100},
						{field:'oppAccName',title:'对方户名',render:'',props:{show:true},width:100},
						{field:'oppAccNo',title:'对方账号',render:'',props:{show:true},width:100},
						{field:'original',title:'来源',render:'',props:{show:true},width:100},
						{field:'serialId',title:'流水ID',render:'',props:{show:true},fixed:'right',width:200},
						{field:'mark',title:'备注',render:'',props:{show:true},fixed:'right',width:100},					
						{field:'export_wln',title:'万里牛',render:'',props:{show:true},fixed:'right',width:200},	
						{field:'export_jindie',title:'金蝶',render:'',props:{show:true},fixed:'right',width:100},
						{field:'export_jindie_type',title:'金蝶模块',render:'',props:{show:true},fixed:'right',width:100},					
						// {
						// 	title: '操作',
						// 	fixed: "right",
						// 	align: 'center',
						// 	width: 65,
						// 	slots: {
						// 		default: ({row}) => {
						// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>]
						// 		}
						// 	}
						// }
				]
				gridOptions.columns.forEach((item)=>{
					if(item.field=='serialNo'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.cdSign==1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
								}
								if(row.cdSign==0){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
								}
								str.push(<span>{row.serialNo}</span>)
								return str
							}
						}
					}
					if(item.field=='export_wln'){
						item.slots = {
							default:({row})=>{
								if(!row.export_wln){
									if(row.export_wln_error){
										return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span>{row.export_wln}</span> 	
								}
							}
						}
					}
					if(item.field=='export_jindie'){
						item.slots = {
							default:({row})=>{
								if(row.export_jindie_sucess!=1){
									if(row.export_jindie_error){
										return <span style="color:#F56C6C;">{row.export_jindie_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span style="color:#67C23A;">已同步</span> 	
								}
							}
						}
					}
				})
				gridOptions.pagerConfig.enabled = true
			},
			list(page,updateForm,other) {					
				let form = JSON.parse(JSON.stringify(updateForm))
				let wlnbankaccount = []
				this.wlnbankoptions.forEach((item)=>{
					if(item.value == updateForm.wlnbank){
						wlnbankaccount.push(item.inst_account)
					}
				})
				form.wlnbankaccount = wlnbankaccount.join(',')
				
				this.getstatistics(form.wlnbankaccount,form.transTime)
				
				return new Promise(resolve => {
					this.$api.report.reportlist(this.reportName,{
						...page,
						...form,
						...this.foreingKey,
						...other,
						...{
							fundtype:this.fundtype,
						}
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			getstatistics(wlnbankaccount,transTime) {
				this.staticloading = true
				let form = this.$refs.flowcheckreport.getProxyInfo().form
					this.$api.reconciliation_bankflow.getSummary({
						onlybanklist: 1,
						wlnbankaccount:wlnbankaccount,
						transTime:transTime
					}).then((res) => {
						this.staticloading = false
						this.statistics = {
							czbal:0,
							diff:0,
							jindiesum:parseFloat(res.jindiesum),
							wlnbal:parseFloat(res.wlnbal),
							wlnsum:parseFloat(res.wlnsum)
						}
						//inst_account
						res.bankAccList.forEach((item)=>{
							item.wlnbal = null
							let wlnaccount = res.wlnbankAccList.find((_item)=>{
								return _item.inst_account == item.bankAcc
							})
							if(wlnaccount){
								item.wlnname = wlnaccount.acc_name
								item.wlncode = wlnaccount.acc_code
								item.wlnbal = wlnaccount.balance
								
							}
						})
						if(form.wlnbank){
							let target = res.bankAccList.find((item)=>{
								return item.wlncode == form.wlnbank
							})
							if(target){
								this.statistics.czbal = parseFloat(target.bal)
								this.statistics.diff = this.statistics.czbal - this.statistics.wlnbal
							}
												
						}
					},()=>{
						this.staticloading = false
					})
			},
			showUnsendwlnChange(e){
				this.foreingKey.showUnsendwln = e?1:0
				this.$refs.flowcheckreport.commitProxy('query')
			},
			showtransferaccountChange(e){
				this.foreingKey.showtransferaccount = e?1:0
				this.$refs.flowcheckreport.commitProxy('query')
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.$refs.flowcheckreport.commitProxy('query')
			},
			showUnrelationChange(e){
				this.foreingKey.unrelation = e?1:0
				this.$refs.flowcheckreport.commitProxy('query')
			},
			bankconfig(){
				this.$refs.bankconfigIndex.modal_show()
			},
			sendjindie(){
				let data =  this.$refs.flowcheckreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendjindie({
							serialNo:item.serialNo,
						}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			sendwln(){
				let data =  this.$refs.flowcheckreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendwln({
							serialNo:item.serialNo,
						}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})				
			},
			checkerror(){
				let data =  this.$refs.flowcheckreport.getTableData().fullData				
				data = data.map((item)=>{
					return {
						id:item.id,
						serialNo: item.serialNo?item.serialNo.trim():null,
						amount:item.amount,
						export_jindie_type:item.export_jindie_type,
						export_jindie_sucess:item.export_jindie_sucess
					}
				})
				let grouptype = this.$Lodash.groupBy(data, 'export_jindie_type')
				for(let i in grouptype){
					let newarr = []
					let groupserialNo = this.$Lodash.groupBy(grouptype[i], 'serialNo')
					for(let j in groupserialNo){
						let obj = groupserialNo[j][0]
						obj.amount = this.$Lodash.sumBy(groupserialNo[j], (item)=>{
							return parseFloat(item.amount)
						})	
						obj.id = groupserialNo[j].map((iditem)=>{
							return iditem.id
						})
						obj.id = obj.id.join(',')
						obj.amount = Math.abs(obj.amount)
						newarr.push(obj)
					}
					grouptype[i] = newarr
				}
				
				
				this.loading = true
				this.$api.reconciliation_bankflow.checkerror({
					data:grouptype,
				}).then((res)=>{
					this.loading = false
					let data = res.filter((item)=>{
						return item.res!=1
					})
					if(!data.length){
						this.$message.success('未发现差异')
						return
					}
					this.checkerrordata = data
					this.$nextTick(()=>{
						this.$refs.checkerror.modal_show()
					})
					
					console.log(data)
				},()=>{
					this.loading = false
				})
		
			},
			positioning(e){
				this.$refs.flowcheckreport.commitProxy('query',{id:e.data})
			},
			cellStyle({
				row
			}) {
				if (row.isreal == 0) {
		
					return {
						backgroundColor: 'rgb(244, 244, 245)'
					}
				}
			},
			paymentsummary() {
				let form = this.$refs.flowcheckreport.getProxyInfo().form
				this.transTime = form.transTime
				this.$refs.statistics.modal_show()
			},

			edit(row){
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			success(){
				this.customreload()
			},
			customreload(){
				this.$refs.flowcheckreport.commitProxy('query')
			},
			exportdetail(e){
				let obj = {}
				obj.data = e.data
				obj.columns = this.$refs.flowcheckreport.getColumns()
				this.$refs[this.exportRef].exportData(obj)
			}
		},
		components: {
			bankconfigIndex,
			statisticsIndex,
			checkerrorIndex
			// editIndex
		}
	}
</script>